import { SocialType } from "shared/SocialsShare/SocialsShare";
import React, { FC } from "react";

export interface SocialsListProps {
  className?: string;
  itemClass?: string;
  socialMediaShare?: SocialType[];
}

const socials: SocialType[] = [
  { name: "", icon: "lab la-facebook-square", href: "https://www.facebook.com/tinyaway/",targetBlank:true},
  { name: "", icon: "lab la-pinterest", href: "https://www.pinterest.com/tiny_away/",targetBlank:true },
  { name: "", icon: "lab la-youtube", href: "https://www.youtube.com/channel/UC0bqRZQeaV5r66ns9mnGf4Q",targetBlank:true },
  { name: "", icon: "lab la-instagram", href: "https://www.instagram.com/tiny.away/",targetBlank:true },
];

const SocialsList: FC<SocialsListProps> = ({
  className = "",
  itemClass = "block",
  socialMediaShare = socials,
}) => {
  return (
    <nav
      className={`nc-SocialsList flex space-x-2.5 text-2xl text-neutral-6000 dark:text-neutral-300 ${className}`}
      data-nc-id="SocialsList"
    >
      {socialMediaShare.map((item, i) => (
        <a
          key={i}
          className={`${itemClass}`}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          title={item.name}
        >
          <i className={item.icon}></i>
        </a>
      ))}
    </nav>
  );
};

export default SocialsList;
